import { render, staticRenderFns } from "./jxszh.vue?vue&type=template&id=78723926&scoped=true&"
import script from "./jxszh.vue?vue&type=script&lang=js&"
export * from "./jxszh.vue?vue&type=script&lang=js&"
import style0 from "./jxszh.vue?vue&type=style&index=0&id=78723926&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78723926",
  null
  
)

export default component.exports